import _, { isUndefined } from 'underscore';
import constants from '../util/constants';
import axios from 'axios';
import downloadFile from 'react-file-download';
import ProductInfo from '../ProductInfo';
import OrderInfo from '../OrderSearch/OrderInfo';
import CustomerInfo from '../CustomerInfo';
import OrderStatusInfo from '../OrderStatusInfo';
import LogisticsExpander from '../Dashboard/LogisticsData/LogisticsExpander';
import React from 'react';
import { Checkbox } from 'react-bootstrap';
import OrderTexts from '../OrderCreate/OrderTexts';
import FontAwesome from 'react-fontawesome';
import Dialog from 'react-bootstrap-dialog';
import * as Grants from '.././util/grants';
import { hasGrant } from '.././util/grantHelper';
import OrderContactInfo from '../OrderContactInfo';

const allocationList = ["PM", "Country", "Grade", "Grammage", "ProdType", "EndUse", "M1", "M2", "M3", "M4", "M5", "M6", "M7", "M8", "M9", "M10", "M11", "M12"];
const { API_BASE_URL } = constants;


function getFilteredData(reactTable) {
    return reactTable.getResolvedState().sortedData.map(m => m._original);
}


function getDataWithNewcolumnNames(columnNames, data) {
    let res = data.map(t1 => _.pick(t1, columnNames.map(x1 => x1.Name)));
    //      tvinga rename på alla kolumner för att få rätt sortering
    columnNames.forEach(x1 => {
        res.forEach(r => {
            if (x1.Name != x1.Header) {
                let tmp = r[x1.Name];
                delete r[x1.Name];
                r[x1.Header] = tmp;
            };
        });
    });
    res = res.map(t1 => _.pick(t1, columnNames.map(x1 => x1.Header)));
    return res;
}

function export2Excel(apiToken, reactTable, fileName, isImperial = false) {

    const data = getFilteredData(reactTable);
    const fields = getExcelColumns(reactTable, isImperial);
    const header = {
        'Authorization': 'Bearer ' + apiToken,
        'Accept': 'application/octet-stream'
    };
    let expData = getDataWithNewcolumnNames(fields, data);
    axios.post(API_BASE_URL + 'Files/Export2Excel', expData, { headers: header, responseType: "blob" })
        .then(result => {
            downloadFile(result.data, fileName)
        })
        .catch(error => {
            alert(error);
        });
}


function replaceAll(originalString, find, replace) {
    return originalString.replace(new RegExp(find, 'g'), replace);
};

function filterMultiple(filter, row){
    let filterValues = filter.value.split(',');
    if(filterValues.length > 1)
    {
        filterValues.forEach((x, y, z) =>{ z[y] = x.trim(); });

        // return filterValues.some(v => ((row[filter.id] || '').toString().toUpperCase().includes(v.toUpperCase())));
        
        for(let i = 0; i<filterValues.length;i++){
            if(((row[filter.id] || '').toString().toUpperCase().includes(filterValues[i].toUpperCase())))
                return true;
        }
    }
    return ((row[filter.id] || '').toString().toUpperCase().includes(filter.value.toUpperCase()));
}

function sortNumber(a, b) {
    if(isNaN(a) || isNaN(b)) return a > b;
    let aNum = Number(a);
    let bNum = Number(b);
    if(aNum === bNum) return 0;
    else return aNum > bNum ? 1 : -1;
}

function filterNumber(filter, row) {
    if (filter.value === "") return true;
    let fv = filter.value.toLowerCase();
    if ((fv.indexOf('>') == -1) && (fv.indexOf('<') == -1) && (fv.indexOf('-') == -1) && row[filter.id] || (row[filter.id] && row[filter.id].toString().toLowerCase().indexOf('x') > -1)) {
        return row[filter.id].toString().toLowerCase().indexOf(fv) > -1;
    }
    return filterLargerOrLessOrExact(filter, row) || filterFromToOrExact(filter, row);
}

function filterFromToOrExact(filter, row) {
    if (filter.value === "") return true;
    let f = replaceAll(filter.value, ',', '.');;
    if (row[filter.id] === undefined || row[filter.id] === null) return false;
    let rowdata = replaceAll(row[filter.id].toString(), ',', '.');

    if (isNaN(rowdata)) return true;
    if (f === rowdata) return true;
    let nrs = f.split('-').filter(s => isNaN(s) === false).map(s => (Number(s))).filter(s => isNaN(s) === false);
    if (nrs.length === 2 && isNaN(nrs[0]) === false && isNaN(nrs[1]) === false) {
        let nr = Number(rowdata);
        return (nr >= nrs[0]) && (nr <= nrs[1]);
    }
    return false;
}

function filterLargerOrLessOrExact(filter, row) {
    if (filter.value === "") return true;
    let d = row[filter.id];
    let f = replaceAll(filter.value, ',', '.');
    if (d === undefined || d === null) return false;
    if (row[filter.id] === undefined || row[filter.id] === null) return false;
    let rowdata = replaceAll(row[filter.id].toString(), ',', '.');
    if (isNaN(rowdata)) return true;
    if (f === rowdata) return true;
    if (f.indexOf('>') === 0) {
        let nr = f.substring(1);
        if (isNaN(nr)) return true;
        return Number(d) > nr;
    }
    if (f.indexOf('<') === 0) {
        let nr = f.substring(1);
        if (isNaN(nr)) return true;
        return Number(d) < nr;
    }
    return rowdata === filter.value;
}

function getExpander(row, field, self, isExpanded) {
    return (<div disabled={row && row.original && row.original.ORDER_ITEM_STATUS && row.original.ORDER_ITEM_STATUS === 'B'} onClick={() => {
        if (row && row.original) {
            if (isExpanded && row.original.TAG === field) {
                field = '';
            }
            self.tell(field, row);
        }
    }}>
        {isExpanded && row.original.TAG === field
            ? <FontAwesome name="caret-up" />
            : <FontAwesome name="caret-down" />
        }
    </div>)
}



function setDataForExpansion(cr_exp, rowAll, apiToken, self, _ccr) {
    let col = 'EXP_' + cr_exp;
    let oldexpanded = self.state.expanded;
    let id = rowAll.viewIndex;
    let idstate = cr_exp == '' ? false : {};
    let newexpanded = oldexpanded;
    newexpanded[id] = idstate;
    let thisexp = { id, idstate };
    let row = rowAll.original;
    const header = {
        'Authorization': 'Bearer ' + apiToken,
        'Accept': 'application/octet-stream'
    };


    if (cr_exp && cr_exp !== '') {
        if (row[col] === undefined || cr_exp === "ITEMTEXTS") {
            if (cr_exp === "ITEMTEXTS") {
                self.props.parentRefresh();
                row['EXP_ITEMTEXTS'] = (
                    <div style={{ padding: "4px" }}>
                        <OrderTexts orderTexts={row.Texts} isDetail={1} isHeader={0} disabled={row.ORDER_ITEM_STATUS === 'B'} />
                    </div>
                );
            }
            if (cr_exp === "PRODUCT_CODE") {
                row[col] = (<ProductInfo productData={undefined} />);
                self.setState({});
                let onum = row.COPIED_FROM_ORDER_NUMBER || row.ORDER_NUMBER;
                let oitemnum = row.COPIED_FROM_ORDER_ITEM_NUMBER || row.ORDER_ITEM_NUMBER;
                let ccr = row.CLIENT_CODE_REGIONAL ? row.CLIENT_CODE_REGIONAL : (self.props && self.props.productCodes && self.props.productCodes.length > 0) ? self.props.productCodes[0].CLIENT_CODE_REGIONAL : 'empty';
                axios.get(API_BASE_URL + `StockSearch/GetProductInfo/?productCode=${row.PRODUCT_CODE}&order_number=${onum}&order_item_number=${oitemnum}&client_code_regional=${ccr}`, { headers: header })
                    .then(result => {
                        row[col] = (
                            <div style={{ padding: "4px" }}>
                                <ProductInfo productData={result.data} />
                            </div>);
                        self.setState({});
                    }).catch(error => {
                        row[col] = undefined;
                        self.setState({});
                        alert("Error getting product info");
                    });
            }
            if (cr_exp === "CLIENT_CODE_REGIONAL") {
                row[col] = (<CustomerInfo customerInfo={undefined} />);
                self.setState({});
                axios.get(API_BASE_URL + `Dashboard/GetCustomerInfo/?order_number=${row.ORDER_NUMBER}&client_code_regional=${row.CLIENT_CODE_REGIONAL}`, { headers: header })
                    .then(result => {
                        row[col] = (
                            <div style={{ padding: "4px" }}>
                                <CustomerInfo customerInfo={result.data} />
                            </div>);
                        self.setState({});
                    }).catch(error => {
                        row[col] = undefined;
                        self.setState({});
                        alert("Error getting customer info");
                    });
            }

            if (cr_exp === "ORDER_COMBO") {
                row[col] = (<OrderInfo orderInfo={undefined} />);
                self.setState({});
                axios.get(API_BASE_URL + `Order/GetOrderInfo/?order_number=${row.ORDER_NUMBER}&order_item_number=${row.ORDER_ITEM_NUMBER}`, { headers: header })
                    .then(result => {
                        row[col] = (
                            <div style={{ padding: "4px" }}>
                                <OrderInfo orderInfo={result.data} apiToken={apiToken} />
                            </div>);
                        self.setState({});
                    }).catch(error => {
                        row[col] = undefined;
                        self.setState({});
                        alert("Error getting order info");
                    });
            }

            if (cr_exp === "ORDER_STATUS") {
                row[col] = (<OrderStatusInfo orderStatus={undefined} />);
                self.setState({});
                axios.get(API_BASE_URL + `Order/GetOrderStatusInfo/?order_number=${row.ORDER_NUMBER}&order_item_number=${row.ORDER_ITEM_NUMBER}`, { headers: header })
                    .then(result => {
                        row[col] = (
                            <div style={{ padding: "4px" }}>
                                <OrderStatusInfo orderStatus={result.data} />
                            </div>);
                        self.setState({});
                    }).catch(error => {
                        row[col] = undefined;
                        self.setState({});
                        alert("Error getting order status info");
                    });

            }
            if (cr_exp === "LOADING_NO") {
                row[col] = (<LogisticsExpander logisticsExpander={undefined} />);
                self.setState({});
                axios.get(API_BASE_URL + `Logistics/GetCallOffItems/?loadingNo=${row.LOADING_NO}`, { headers: header })
                    .then(result => {
                        row[col] = (
                            <div style={{ padding: "4px" }}>
                                <LogisticsExpander logisticsExpander={result.data} /> 
                            </div>);
                            // skapa ny component som kan skriva ut info om lastplaner istället för orderstatusinfo
                        self.setState({});
                    }).catch(error => {
                        row[col] = undefined;
                        self.setState({});
                        alert("Error getting logistics data");
                    });
            }

            if(cr_exp === "ORDER_ISSUED") {
                row[col] = (<OrderContactInfo orderContact={undefined} /> );
                self.setState({});
                axios.get(API_BASE_URL + `Order/GetOrderContactInfo/?order_number=${row.ORDER_NUMBER}`, {headers: header})
                    .then(result => {
                        row[col] = (
                            <div style={{ padding: "4px" }}>
                                <OrderContactInfo orderContact={result.data}/>
                            </div>);
                        self.setState({});
                    }).catch(error => {
                        row[col] = undefined;
                        self.setState({});
                        alert("Error getting order contact information");
                    })
            }

        }
    }

    self.setState({ expanded: newexpanded });
    row.TAG = cr_exp;
}

function getcolumnNamesAndHeaders(columns, cols, isImperial) {
    columns.forEach(c => {
        if (c.columns && c.columns.length > 0) {
            return getcolumnNamesAndHeaders(c.columns, cols, isImperial);
        }
        
        if (c.Header && c.Header.length > 0 && c.accessor && c.accessor.length > 0) {
                cols.push({ Name: c.accessor, Header: c.Header });
        }

        if(c.Header?.props) {
            cols.push({ Name: c.accessor, Header: isImperial ? c?.Header?.props?.value_imperial : c?.Header?.props?.value_metric});
        }
    });
    return cols;
}

function getExcelColumns(reactTable, isImperial) {
    return getcolumnNamesAndHeaders(reactTable.props.columns, [], isImperial);
}

function getSum(data, field) {
    
    if (!data || data.length === 0) return 0;
    const doSum = (total, num) => { if (total == '') total = 0; if (num == '') num = 0; return parseFloat(total) + parseFloat(num) };
    return Math.round([...data.filter(v => !isNaN(v[field])).map((v => v[field]))].reduce(doSum));
}

function getBool(row, prop) {
    return row.original[prop] == true;
}

function getBoolColumn( header, field, width, self, disabled = false)
{
  return {
    Header: header,
    maxWidth:width,
    id:header,
    Cell: row => (
      <div className="rt-checkbox">
            <input type="checkbox" disabled={row.original.ORDER_ITEM_STATUS === "B"} onChange={(e) => {
                let codes = ["FSC", "PEFC", "CW_MARK"];
                codes.forEach(c => {
                    if (c == field) {
                        row.original[c] = e.target.checked;
                    }
                    else {
                        row.original[c] = false;
                    }
                })
                self.setState({});
            }}
                checked={getBool(row, field)}
                disabled={disabled}></input>
      </div>
    )
  };
}

function getNumberColumn(header, field, width, self, disabled) {
    let wstyle = { width: (width - 10) + 'px' };
    return {
        Header: header,
        maxWidth: width,
        id: header,
        Cell: row => (
            <input type="number" className="form-control input-sm"
                disabled={disabled}
                style={wstyle}
                onChange={(e) => {
                    row.original[field] = e.target.value;
                    self.setState({});
                }}
                value={row.original[field]}
                min="0"></input>
        )
    };
}

function getTextColumn(header, field, width, self, dataAsTooltip, _maxLength) {
    return {
        Header: header,
        maxWidth: width,
        id: header,
        accessor: field,
        Cell: row => (
            <input disabled={row.original.ORDER_ITEM_STATUS && row.original.ORDER_ITEM_STATUS === "B"} maxLength={_maxLength && (_maxLength == null ? '' : _maxLength)} type="text" className="form-control input-sm" onChange={(e) => {
                row.original[field] = e.target.value;
                self.setState({});
            }}
                title={dataAsTooltip && (row.original[field] !== null ? row.original[field] : '')}
                value={row.original[field] !== null ? row.original[field] : ''} ></input>
        )
    };
}

function getLabelColumn(header, field, width, self, dataAsTooltip) {
    return {
        Header: header,
        maxWidth: width,
        minWidth: width,
        accessor: field,
        id: header,
        Cell: row => (
            <span
                disabled={true}
                title={dataAsTooltip && (row.original[field] !== null ? row.original[field] : '')}>
                {row.original[field]}
            </span>
        )
    };
}

function findTargetColumn(event) {
    if (allocationList.includes(event.name))
        return event.name;
    let name = null;
    if (event.classList) {
        event.classList.forEach((cl) => {
            if (allocationList.includes(cl)) {
                name = cl;
            }
        });
    };

    if (event.childNodes) {
        event.childNodes.forEach((child) => {
            if (child.classList) {
                child.classList.forEach((ccl) => {
                    if (allocationList.includes(ccl)) {
                        name = ccl;
                    }
                });
            };

            if (child.childNodes) {
                child.childNodes.forEach((mini) => {
                    if (mini.classList) {
                        mini.classList.forEach((mcl) => {
                            if (allocationList.includes(mcl)) {
                                name = mcl;
                            }
                        });
                    };
                });
            }
        });
    }

    // Om den kommer hit fann den inte rätt klass på varken target eller childs, 
    // om det är selectbox behöver den förmodligen gå uppåt eftersom selectboxen är nästlad långt ner

    return name;
}

function removeRow(data, row, self, refreshMethod, title, body, disabled = false) {
    let pos = data.indexOf(row);
    if (pos > -1) {
        if (disabled) {
            let nothing = 'nothing';
        }
        else {
            data[pos]['ToBeDeleted'] = 1;
            self.setState({});
            setTimeout(function () {
                self.dialog.show({
                    title,
                    body,
                    actions: [
                        Dialog.CancelAction(() => {
                            self.setState({});
                        }),
                        Dialog.OKAction(() => {
                            let pos = data.indexOf(row);
                            if (pos > -1) {
                                data.splice(pos, 1);
                                if (refreshMethod) {
                                    refreshMethod()
                                };
                                self.setState({});
                            }
                        })
                    ]

                });
            }, 200);
        }
    }
}

export { findTargetColumn, export2Excel, sortNumber, filterMultiple, filterNumber, getFilteredData, getSum, getBoolColumn, getTextColumn, getLabelColumn, getNumberColumn, removeRow, setDataForExpansion, getExpander };